module.exports = __webpack_public_path__ + "img/nasa-space-apps.99b20af5.png";